import { render, staticRenderFns } from "./DepositByAccountType.vue?vue&type=template&id=019bd43a&scoped=true&"
import script from "./DepositByAccountType.vue?vue&type=script&lang=js&"
export * from "./DepositByAccountType.vue?vue&type=script&lang=js&"
import style0 from "./DepositByAccountType.vue?vue&type=style&index=0&id=019bd43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bd43a",
  null
  
)

export default component.exports